import React from 'react'
import NorthstarHubComp from './NorthstarHubComp'

function JobBoardComp() {
  return <NorthstarHubComp initialTrack='career' />
}

export default JobBoardComp
